import React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import "./index.css";
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";

import en from "./translations/en/common.json";
import fr from "./translations/fr/common.json";


i18next.init({
    interpolation: { escapeValue: false }, 
    lng: 'fr_fr',
    resources: {
      en_us: {
          common: en
      },
      fr_fr: {
          common: fr
      }
    },
  });

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<I18nextProvider i18n={i18next}><App /></I18nextProvider>);
